import React from "react";
import { Link } from "react-router-dom";
import { Badge, Box, IconButton, Link as MuiLink, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, } from "@material-ui/core";
import { paths } from "frontend/src/pages/paths/index";
import { TrackRow } from "frontend/src/ui/track-row";
import { TrackPlayerButton } from "frontend/src/ui/track-player-button";
import { Add, Delete } from "@material-ui/icons";
export var ViewerAddableAudioAdvertisements = function (_a) {
    var tracks = _a.tracks;
    if (tracks.empty) {
        return (React.createElement(Box, { style: { paddingLeft: 16, paddingBottom: 16 } },
            React.createElement(Typography, null,
                "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043D\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0435\u043A\u0430. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0445 ",
                "",
                React.createElement(MuiLink, { to: paths.business.owner.files.index(), component: Link }, "\u0437\u0434\u0435\u0441\u044C"),
                ".")));
    }
    return (React.createElement(Box, null,
        React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { width: "5%" }),
                        React.createElement(TableCell, { width: "45%" }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                        React.createElement(TableCell, { width: "45%" }, "\u0414\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C"),
                        React.createElement(TableCell, { width: "5%" }),
                        React.createElement(TableCell, { width: "5%" }))),
                React.createElement(TableBody, null, tracks.items.map(function (track) { return (React.createElement(TrackRow, { isSelectedForPlayer: track.selected, key: track.id },
                    React.createElement(TableCell, null,
                        React.createElement(TrackPlayerButton, { isLoading: track.loading, onPause: track.actions.pause, onPlay: track.actions.play, isPlaying: track.playing })),
                    React.createElement(TableCell, null, track.title),
                    React.createElement(TableCell, null, track.duration),
                    React.createElement(TableCell, null,
                        React.createElement(IconButton, { size: "small", onClick: track.actions.add },
                            React.createElement(Add, null))),
                    React.createElement(TableCell, null, track.addCount ? (React.createElement(Box, { visibility: track.addCount ? "visible" : "hidden" },
                        React.createElement(Tooltip, { title: "Удалить" },
                            React.createElement(Badge, { badgeContent: track.addCount, color: "secondary", invisible: track.addCount < 2 },
                                React.createElement(IconButton, { size: "small", onClick: track.actions.remove },
                                    React.createElement(Delete, null)))))) : (React.createElement(Box, { height: 30, width: 30 }))))); }))))));
};
